import React from 'react'

const TotalCount = ({ total, activeTab }) => {
    return (
        <>
            {(activeTab === "lender" || activeTab === "program") && <div className='total_card'>
                <div className='total_card_child'>
                    <span className='card_total_value'> {total?.lead_assigned}</span>
                    <span>Case Assigned</span>
                </div>
                <div className='total_card_child'>
                    <span className='card_total_value'>{total?.lender_pending}</span>
                    <span>Pending</span>
                </div>
                <div className='total_card_child'>
                    <span className='card_total_value'>{total?.sanction_rejected}</span>
                    <span>Rejected</span>
                </div>
                <div className='total_card_child'>
                    <span className='card_total_value'>{total?.pre_sanction_approved + total?.sanction_approved}</span>
                    <span>Sanctioned</span>
                </div>
                <div className='total_card_child'>
                    <span className='card_total_value'>{total?.disbursal_pending}</span>
                    <span>Disbursal Pending</span>
                </div>
                <div className='total_card_child'>
                    <span className='card_total_value'>{total?.disbursal_rejected}</span>
                    <span>Disbursal Rejected</span>
                </div>
                <div className='total_card_child'>
                    <span className='card_total_value'>{isNaN(total?.disbursal_portfolio + total?.disbursal_lender_decision)? 0 : total?.disbursal_portfolio + total?.disbursal_lender_decision}</span>
                    <span>Disbursed</span>
                </div>
            </div>}
            {/* {activeTab === "co_lending" && <div className='total_card_co_landing'>
                <div className='total_card_child_co_landing'>
                    <span className='card_total_value'>{total?.option_1}</span>
                    <span>Option 1</span>
                </div>
                <div className='total_card_child_co_landing'>
                    <span className='card_total_value'>{total?.['option_1_(PS)']}</span>
                    <span>Option 1 (PS)</span>
                </div>
                <div className='total_card_child_co_landing'>
                    <span className='card_total_value'>{total?.option_2}</span>
                    <span>Option 2</span>
                </div>
                <div className='total_card_child_co_landing'>
                    <span className='card_total_value'>{total?.DA}</span>
                    <span>DA</span>
                </div>
            </div>
            } */}
        </>
    )
}

export default TotalCount